export default {
	tenantId: "fubon",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "fubon"
	}
}
